import * as types from './mutation-types'

export const deleteReview = ({ commit, dispatch, state }, promotion) => {
    let route = `rating/${promotion}/delete`
    return new Promise((resolve, reject) => {
        window.axios.delete(route).then((response) => {
            dispatch('loadOfflineReviewsCount')
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}


export const updateReviewStatus = ({ commit, dispatch, state }, {id,status}) => {
    return new Promise((resolve, reject) => {
        window.axios.put('rating/' + id + '/set/online',{status: status}).then((response) => {
            dispatch('loadOfflineReviewsCount')
            resolve(response)
        }).catch((err) => {
            reject(err)
        })
    })
}

// Nombre d'avis « Non publié » : alimente le point rouge du menu « Avis clients »
export const loadOfflineReviewsCount = ({ commit }) => {
    return window.axios.get('get/rating/offline/count').then((response) => {
        commit(types.SET_OFFLINE_REVIEWS_COUNT, response.data?.count || 0)
        return response
    }).catch(() => {})
}
